const EVENT_ATTRIBUTES = {
  INVESTMENT_TYPE: "investment_type",
  CARD_CLICK: "card_click",
  ENTER_AMOUNT: "enter_amount",
  MONTHLY_DATE_SELECTED: "monthly_date_selected",
  MONTHLY_SIP_DATE: "monthly_sip_date",
  SELECT_A_TARGET_YEAR: "select_a_target_year",
  SIP_AMOUNT: "sip_amount",
  ENTER_TARGET_AMOUNT: "enter_target_amount",
  PARK_SAVINGS_FOR: "park_savings_for",
  DEFAULT_AMOUNT: "default_amount",
  FUND_NAME: "fund_name",
};

export default EVENT_ATTRIBUTES;
